
import { defineComponent } from 'vue';

import { useStore } from 'vuex';

import ModalHeader from '@/modules/modals/components/ModalHeader.vue';
import ModalBody from '@/modules/modals/components/ModalBody.vue';
import ModalFooter from '@/modules/modals/components/ModalFooter.vue';
import ModalService from '@/modules/modals/services/modalService';

export default defineComponent({
    components: { ModalHeader, ModalBody, ModalFooter },
    props: {
        modalSize: {
            default: '',
            required: false,
            type: String
        },
        message: {
            default: '',
            required: true,
            type: String
        },
        title: {
            default: '',
            required: false,
            type: String
        },
        buttons: {},
        includeModalHeader: {
            default: false,
            required: false,
            type: Boolean
        }
    },
    data(props) {
        return {
            modal: null as any,
            modalButtons: props.buttons as any
        };
    },
    setup() {
        const store = useStore();
        return {
            store
        };
    },
    mounted() {
        const modalElement = this.$refs.confirmation;
        this.modal = ModalService.initialize(modalElement, this);
        ModalService.size(modalElement, this.modalSize);
        ModalService.open(this.modal);

        this.processButtons();
    },
    methods: {
        processButtons() {
            let hasCloseButton = false;
            for (const idx in this.modalButtons) {
                const label = this.modalButtons[idx]['label'];

                // Check for close button
                if (this.isCloseButton(label)) {
                    hasCloseButton = true;
                }
            }

            if (!hasCloseButton) {
                this.modalButtons.push(this.generateCloseButton());
            }
        },
        isCloseButton(label: string) {
            return label.toLowerCase() === 'no' || label.toLowerCase() === 'close' || label.toLowerCase() === 'cancel' ? true : false;
        },
        isDismiss(label: string) {
            return this.isCloseButton(label) ? 'modal' : false;
        },
        generateCloseButton() {
            return { label: 'Close', css: 'btn-outline-secondary' };
        },
        fn(callback: any) {
            callback();
            ModalService.hide(this.modal);
        }
    }
});
